import * as api from 'config/axios';
import * as endpoints from './endpoints';
import { getToken } from 'utils/common/session';

const getEulaReqOptions = () => {
  const accessToken = getToken();

  let options = {
    headers: {
      Authorization: 'Bearer ' + accessToken,
    },
  };

  return options;
};

/**
 * User login service
 * @param {object} data user login information
 */
export const getEulaService = () => {
  const options = getEulaReqOptions();
  return api.sendGet(endpoints.EULA_GET_ENDPOINT, options);
};

/**
 * User login service
 * @param {object} data user login information
 */
export const getEulaForMfaService = (loginSession) => {
  const options = {
    params: {
      loginSession,
    },
  };
  return api.sendGet(endpoints.GET_EULA_FOR_MFA, options);
};

/**
 * User accept eula
 * @param {object} data
 */
export const acceptEulaService = (eulaId) => {
  const data = {
    eulaId,
  };
  const options = getEulaReqOptions();
  return api.sendPost(endpoints.EULA_ACCEPT_ENDPOINT, data, options);
};
